import {
  useApi,
  type SLAFilteringDtoOptions,
  type Slas200Response,
  type SLASortingDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

type Params = {
  sort?: SLASortingDtoOptions;
  filter?: SLAFilteringDtoOptions;
  page?: number;
  limit?: number;
  enabled?: boolean;
};

export type UseIssueTypeSlasParams = {
  issueType: string;
  issueSubtype?: string;
};

export function useIssueTypeSlas(params: Params) {
  const {
    page = 0,
    limit = 10,
    sort = {},
    filter = {},
    enabled = true,
  } = params;

  const api = useApi();

  return useQuery<Slas200Response, ExtendedAxiosError>({
    queryKey: ['issue-type-slas', sort, filter, page, limit],
    queryFn: () =>
      api.slasApi.getSlas(sort, filter, page, limit).then((r) => r.data),
    enabled,
    meta: {
      handleError: true,
    },
  });
}

export function useIssueTypeAndSubtypeSlas({
  issueType,
  issueSubtype,
}: UseIssueTypeSlasParams) {
  const slas = useIssueTypeSlas({
    filter: {
      issueType,
      issueSubtype,
    },
    enabled: !!issueType,
  });

  return {
    isLoading: slas.isLoading,
    data: slas.data?.data ?? [],
    isFetching: slas.isFetching,
  };
}
